export default {
  namespaced: true,
  state: {
    imageUrl: null,
    linkUrl: null,
    backgroundColorCode: null
  },
  getters: {
    imageUrl: state => state.imageUrl,
    linkUrl: state => state.linkUrl,
    backgroundColorCode: state => state.backgroundColorCode,
  },
  mutations: {
    setImageUrl(state, imageUrl) {
      state.imageUrl = imageUrl
    },
    setLinkUrl(state, linkUrl) {
      state.linkUrl = linkUrl
    },
    setBackgroundColorCode(state, backgroundColorCode) {
      state.backgroundColorCode = backgroundColorCode
    },
  },
  actions: {
    async initBanner({ commit, dispatch }) {
      // バナー情報を取りに行く
      const args = { __apiOptions: { noErrorDialog: true, noDisplayLoading: true } }
      const bannerInfo = await dispatch("api/getBannerInfo", args, { root: true })
      if(bannerInfo) {
        commit('setImageUrl', bannerInfo.image_url);
        commit('setLinkUrl', bannerInfo.link_url);
        commit('setBackgroundColorCode', bannerInfo.background_color_code);
        return;
      }
      // エラーの場合
      commit('setImageUrl', null);
      commit('setLinkUrl', null);
      commit('setBackgroundColorCode', null);
    }
  },
}